export default function Pets({onBackToResults}) {
  return (
    <div onClick={onBackToResults} className="pets-indicator">
      <span className="home-icon">🐕</span>
      <span className="home">Pets</span>
    </div>
  )
}